import React, { useState } from 'react'
import Button from 'components/shared/app/Button';
import BillingForm from './BillingForm';

const SignupPayment = (props) => {
    const [error, setError] = useState('');

    const onCardSubmit = (pd) => {
        if (pd.paymentId) {
            props.submitPaymentMethod(pd.paymentId);
        }
    }

    const onError = (e) => {
        console.log('error', e);
    }

    return (
        <div className="step signup-payment form">

            <div className="font-plain-large bold pad lg center">Enter your payment information:</div>

            <div className="flex-col billing-info">
                <BillingForm onCardSubmit={onCardSubmit} onError={onError}/>
            </div>

            <div className="button-row col">
                {/* <Button className="margin lg" round simple bold filled center color="white" icon={props.loading ? <Spinner size="fit" className="icon" color="blue" /> : <img src={arrowIcon} />} iconPosition="right" textPosition="center" onClick={submit}>
                    Submit
                </Button> */}
                <Button round simple bold center color="white" textPosition="center" onClick={() => props.setSignupState(3)}>
                    Back
                </Button>
            </div>

            { error != '' && <div className="error status center font-plain-medium">{error}</div> }

        </div>
    )
}

export default SignupPayment;